export const PERIOD = {
  HEBDO: 'hebdomadaire',
  MENSUELLE: 'mensuelle',
  SEMESTRIELLE: 'semestrielle',
  ANNUELLE: 'annuelle',
}
